import React from "react";
import { Navigate } from "react-router-dom";
import { useUserStore } from "../store/userStore";

interface ProtectedRouteProps {
  children: JSX.Element;
  adminOnly?: boolean;
}

export default function ProtectedRoute({ children, adminOnly = false }: ProtectedRouteProps) {
  const user = useUserStore((state) => state.user);

  if (!user) {
    // Перенаправление на страницу авторизации, если пользователь не авторизован
    return <Navigate to="/auth" replace />;
  }

  if (adminOnly && !user.isAdmin) {
    // Перенаправление, если доступ только для админов
    return <Navigate to="/" replace />;
  }

  return children;
}
